'use strict';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Span from '../../tag/Span';
import Row from '../../tag/Row';
import { isEmpty } from 'lodash';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTButton from '../../tag/OTButton';
import {
  compareStatus,
  KAYTTAJA,
  PYYDETTY,
  EITIETOA,
} from '../../../definitions/PolkuConstants';
import OTIcon from '../../tag/OTIcon';
import { doRedirect } from '../../../data/service/tayspolku/actions';
import Alert from '../../Alert';

import enabledlogoSrc from '../../../images/tays-logo.png';
import disabledLogoSrc from '../../../images/tays-logo-gray.png';
import TaysPolkuRedirectModal from './TaysPolkuRedirectModal';

const TaysPolkuServiceCard = (props) => {
  const [redirectLink, setRedirectLink] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { taysPolku, doRedirect, integrations } = props;

  const buttons = [];

  const taysPolkuObject = _.find(integrations.data, { name: 'Tays polku' });

  const handleOnClick = () => {
    doRedirect().then(({ payload }) => {
      setRedirectLink(payload);
      setShowModal(true);
    });
  };

  if (
    compareStatus(taysPolkuObject.status, KAYTTAJA) ||
    compareStatus(taysPolkuObject.status, PYYDETTY)
  ) {
    buttons.push(
      <OTButton
        key="redirect"
        message={`care.plan.status.${taysPolkuObject.status}.button`}
        onClick={handleOnClick}
      />
    );
  }

  return (
    <>
      <FormattedMessage id={`care.plan.general.title`}>
        {(txt) => <h2>{txt}</h2>}
      </FormattedMessage>
      {taysPolku.error && <Alert message={`default.error.message`} />}
      {taysPolkuObject.status !== EITIETOA && (
        <>
          <Row className="tayspolku-block ot-card__care-plan-card ot-card">
            <Span len="12">
              <Span len="4">
                {taysPolkuObject.status === KAYTTAJA ? (
                  <div className={`ot-card__care-plan-card`}>
                    <img src={enabledlogoSrc} alt={''} />
                    <FormattedMessage id={`care.plan.general.title`}>
                      {(txt) => (
                        <p className="text-center ot-card__image-title">
                          {txt}
                        </p>
                      )}
                    </FormattedMessage>
                  </div>
                ) : (
                  <div className={`ot-card__care-plan-card`}>
                    <img src={disabledLogoSrc} alt={''} />
                    <FormattedMessage id={`care.plan.general.title`}>
                      {(txt) => (
                        <p className="text-center ot-card__image-title ot-card__image-title--disabled">
                          {txt}
                        </p>
                      )}
                    </FormattedMessage>
                  </div>
                )}
              </Span>
              <Span len="6">
                <FormattedMessage
                  id={`care.plan.status.${taysPolkuObject.status}.desc`}
                >
                  {(txt) => (
                    <p
                      className={`care-plan-status-desc care-plan-status-${taysPolkuObject.status}-desc`}
                    >
                      {txt}
                    </p>
                  )}
                </FormattedMessage>

                {!isEmpty(buttons) && (
                  <OTButtonGroup collapseOnMobile expectedCount="1" type="big">
                    {buttons}
                  </OTButtonGroup>
                )}
              </Span>

              {taysPolkuObject.status !== PYYDETTY && (
                <Span
                  len="2"
                  className={`care-plan-status care-plan-status__${taysPolkuObject.status}`}
                >
                  <OTIcon config={{ type: 'fa', name: 'fa-check' }} />
                  <FormattedMessage
                    id={`care.plan.status.${taysPolkuObject.status}`}
                  >
                    {(txt) => <>{txt}</>}
                  </FormattedMessage>
                </Span>
              )}
            </Span>
          </Row>
        </>
      )}
      {showModal && (
        <TaysPolkuRedirectModal
          redirectLink={redirectLink}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    taysPolku: state.services.taysPolku,
    integrations: state.services.integrations,
  };
};

export default connect(mapStateToProps, { doRedirect })(TaysPolkuServiceCard);
